import "./styles.css";

function Spinner({ small }) {
  return <div className={"Spinner" + (small ? " small" : "")}>Loading...</div>;
}

export default Spinner;
